import React, {FunctionComponent, useEffect, useState} from "react";
import Loader from 'react-loader';

import {FormContext, useForm} from "react-hook-form";
import {useAlert} from 'react-alert';
import {Steps} from "./SearchTutoringFormSteps/Steps";
import {connect} from "react-redux";
import {back, next, setData, setFormValues} from "../redux/actions/SearchTutoring.actions";

import SiteStyle from "../styles/site.module.scss";
import InputStyle from "../styles/input.module.scss";
import ProgressStyle from "../styles/progressbar.module.scss";

import {fetchSearchTutoringData, submitForm} from '../api/GiveTutoringForm';

import ProgressBarSearchTutoring from "./SearchTutoringFormSteps/ProgressBarSearchTutoring";

import FirstStep from "./SearchTutoringFormSteps/FirstStep";
import SecondStep from "./SearchTutoringFormSteps/SecondStep";
import Finished from "../components/Finished";
import {useSubmit} from "../helpers/UseSubmit";
import {ERROR_TEXT} from "../Text/text";
import useButtons from "../helpers/UseButtons";
import RenderRemoteEither from "../components/RenderRemoteEither";
import {SearchTutoringData} from "./SearchTutoringFormSteps/SearchTutoringData";
import {failure, pending, RemoteData, success} from "@devexperts/remote-data-ts/es6";
import {Either} from "fp-ts/es6/Either";
import {Errors} from "io-ts";
import {GiveTutoringData} from "./GiveTutoringFormSteps/GiveTutoringData";
import {initial} from "@devexperts/remote-data-ts";

const EnterJobForm: FunctionComponent<{
    step: number;
    data: any;
    next: any;
    back: any;
    setData: any;
    direction: string;
}> = ({step, next, back, setData, data}) => {
    const methods = useForm();
    const alert = useAlert();

    const {sending, onSubmit} = useSubmit({
        showErrorsAction: alert.show,
        formFinished: next,
        submitAction: submitForm,
        data: () => ({...data, suche_type: 'nehmen', faecher_table: JSON.stringify(data.faecher_table)}),
        errorText: ERROR_TEXT
    })

    const validatedNext = async () => {
        const fields: any = Steps;
        const isValid = await methods.triggerValidation(fields[`${step}`]);

        if (isValid) {
            setData(methods.getValues());
            next();
        }
    };

    const validateBack = () => {
        if (step > 1) {
            back();
        }
    };

    const {submitButton, nextButton, prevButton} = useButtons(step, Object.keys(Steps).length)

    const [formValues, setFormValues] = useState<RemoteData<string, Either<Errors, GiveTutoringData>>>(initial);
    useEffect(() => {
        setFormValues(pending);
        fetchSearchTutoringData().then(data => {
            setFormValues(success(data));
        }).catch(e => setFormValues(failure(e)))
    }, []);


    const renderStep = (step: number, formValues: SearchTutoringData) => {
        switch (step) {
            case 1:
                return <FirstStep setData={setData} formValues={formValues} data={data} {...methods} />;

            case 2:
                return <SecondStep setData={setData} formValues={formValues} data={data} {...methods} />;

            case 3:
                return <Finished text={"Wir haben deine Anfrage erhalten und werden dich in Kürze kontaktieren."}/>;

            default:
                return <></>
        }
    };

    return (
        <div className={SiteStyle.formContainer}>
            <div className={ProgressStyle.wrapper}>
                <ProgressBarSearchTutoring/>
            </div>
            <FormContext {...methods}>
                <form
                    className={InputStyle.form}
                    onSubmit={methods.handleSubmit(onSubmit)}
                >
                    <RenderRemoteEither showLoadingOnInitial={true} renderStep={renderStep} step={step} formValues={formValues}/>

                    <div className={InputStyle.btnWrapper}>
                        <button
                            className={InputStyle.btn}
                            disabled={!prevButton}
                            onClick={validateBack}
                        >
                            zurück
                        </button>
                        {submitButton ? (
                            <button
                                className={InputStyle.btn}
                                disabled={!submitButton}
                                type="submit"
                            >Senden {sending ? <Loader loaded={false}/> : ''}</button>
                        ) : (
                            <button
                                className={InputStyle.btn}
                                disabled={!nextButton}
                                onClick={(e) => {
                                    e.preventDefault();
                                    validatedNext()
                                }}
                            >
                                Nächster Schritt
                            </button>
                        )}
                    </div>
                </form>
            </FormContext>
        </div>
    );
};

const mapStateToProps = (state: any) => {
    return {
        step: state.SearchTutoringForm.step,
        data: state.SearchTutoringForm.data,
        direction: state.SearchTutoringForm.direction
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        next: () => dispatch(next()),
        back: () => dispatch(back()),
        setData: (data: Object) => dispatch(setData(data)),
        setFormValues: (data: Object) => dispatch(setFormValues(data))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EnterJobForm);
